var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entornoProyecto !== 'production')?_c('MainContainer',[_c('dl',{staticClass:"info-entorno"},[_c('dt',[_vm._v("V")]),_c('dd',[_vm._v(_vm._s(_vm.versionProyecto))]),_c('dt',[_vm._v("Ambiente: ")]),_c('dd',[_vm._v(_vm._s(_vm.entornoProyecto))]),_c('dt',[_vm._v("Actualización: ")]),_c('dd',[_vm._v(_vm._s(_vm.actualizacionProyecto))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }